import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { MatDialogModule } from '@angular/material/dialog';
import { OverlaySimpleComponent } from './overlay-simple.component';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        SvgIconModule,
    ],
    exports: [ OverlaySimpleComponent ],
    declarations: [ OverlaySimpleComponent ],
    entryComponents: [ OverlaySimpleComponent ],
})
export class OverlaySimpleModule {}
